export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12601.43ada453.jpg";